import * as React from "react";
import {
  Col,
  Collapse,
  ControlLabel,
  FormGroup,
  HelpBlock,
} from "react-bootstrap";

const RequiredMarker = () => <span className="text-danger">&nbsp;*</span>;

interface Props {
  label: string;
  required: boolean;
  helpText?: string;
  errorText?: string;
  validationState: "error" | null;
  visible: boolean;
  // Raw question name. When provided, it's sanitised into an HTML id and handed
  // to react-bootstrap's FormGroup, which wires the label's `htmlFor` to the
  // control's `id` — giving single-control questions (text/select) an
  // accessible name. Omit for multi-control questions (radios/checkboxes),
  // whose options already carry their own labels.
  controlId?: string;
  children: any; // why do we need this now?
}

// HTML ids can't contain spaces and shouldn't start with a digit; question
// names contain both (e.g. "Phone (Mobile)", "Referral.Main"). Slugify them.
const toControlId = (name: string): string =>
  "q-" + name.replace(/[^a-zA-Z0-9_-]+/g, "-").replace(/(^-+|-+$)/g, "");

class QuestionRow extends React.PureComponent<Props> {
  render() {
    const {
      label,
      required,
      helpText,
      errorText,
      visible,
      validationState,
      controlId,
    } = this.props;
    // console.log(label, helpText, validationState, errorText);
    return (
      <Collapse in={visible}>
        <FormGroup
          validationState={validationState}
          controlId={controlId ? toControlId(controlId) : undefined}
        >
          <Col xs={12} sm={4}>
            <ControlLabel>
              {label}
              {required && <RequiredMarker />}
            </ControlLabel>
          </Col>
          <Col xs={12} sm={8}>
            {this.props.children}
            {helpText && <HelpBlock>{helpText}</HelpBlock>}
            {validationState && <HelpBlock>{errorText}</HelpBlock>}
          </Col>
        </FormGroup>
      </Collapse>
    );
  }
}

export default QuestionRow;
